// All or portions of this file Copyright © 2019 Amazon Web Services, Inc. or its affiliates or licensors.
// All rights reserved. For full license terms and conditions, please see the LICENSE file at the root of
// this distribution (the "License") or go to https://content.sumerian.amazonaws.com/engine/latest/license.txt.
// All use of the software is governed by the License. All materials are made available on an "AS IS" BASIS, WITHOUT
// WARRANTIES OR CONDITIONS OF ANY KIND, express or implied. Do not remove or modify any license notices.
import Action from 'core/fsmpack/statemachine/actions/Action';

/**
 * @autodoc apply FsmAction
 */
class PauseParticleSystemAction extends Action {
  enter(fsm) {
    const entity = fsm.getOwnerEntity();
    if (!entity || !entity.particleSystemComponent) { return; }
    entity.particleSystemComponent.pause();
  }
}

PauseParticleSystemAction.external = {
  key: 'PauseParticleSystem',
  deprecatedKey: 'pauseParticleSystem',
  name: 'Pause Particle System',
  type: 'misc',
  description: 'Pauses the particle system on the entity.',
  canTransition: false,
  parameters: [],
  transitions: [],
};

PauseParticleSystemAction.register();

export default PauseParticleSystemAction;
